export default __webpack_public_path__ + "static/media/ig-post-4.fdb145ac.jpeg";